<div class="main">
    @defer (when !pureOriginalsService.tableIsLoading()) {
        <div class="table-container"
             infinite-scroll
             [scrollWindow]="false"
             [infiniteScrollDistance]="2"
             (scrolled)="pureOriginalsService.onScrollFaultyPureOriginalsByFaultyEcuBuildsTable()">


                <app-pure-originals-table
                        [pureOriginals]="pureOriginalsService.pureOriginals()"
                        [actionsTemplate]="customActions"
                        [sortDirectionValues]="pureOriginalsService.sortDirectionValues()"
                        [displayedTableHeaders]="pureOriginalsService.displayedTableHeaders()"
                        [displayedOriginalColumns]="pureOriginalsService.displayedOriginalColumns()"
                        (changeSortDirection)="changeSortDirection($event)"
                        [headerActionButton]="true"
                        [isLoadingTemplate]="isLoading()"
                        [headerButtonResetValue]="resetHeaderActionValue()"
                        [disableSortButton]="false"
                        (selectedIdsOutput)="getSelectedIdOutputs($event)"
                />


            <ng-template #customActions let-element>
                <div class="actions-row">

                    <button class="table-buttons"
                            (click)="downloadVersionFile(element.id, element.winOlsReference, 'PURE_ORIGINAL_BASE')"
                            [disabled]="isDownloadInProgress(element.id)"
                            matTooltip="Download file"
                            matTooltipPosition="below">
                        <i class="bi bi-file-earmark-arrow-down"></i>
                    </button>


                    <label class="table-buttons" matTooltip="Upload Ini file" matTooltipPosition="below">
                        <i class="bi bi-file-arrow-up"></i>
                        <input type="file"
                               hidden
                               (change)="uploadIni($event, element.id)" />
                    </label>

                    <button class="table-buttons"
                            [disabled]="!element.id"
                            (click)="openPureOriginalDetails(+element.id)">
                        <i class="bi bi-eye"></i>
                    </button>

                    <div class="checkbox-wrapper-18">
                        <div class="round">
                            <input type="checkbox"
                                   [id]="element.id"
                                   [checked]="isElementSelected(element.id)"
                                   (change)="viewDetails($event, element)" />
                            <label [for]="element.id"></label>
                        </div>
                    </div>

                </div>
            </ng-template>


        </div>
    } @placeholder (minimum 300ms) {
        <div class="skeleton-wrapper">
            <app-skeleton-table></app-skeleton-table>
        </div>
    }

    <div class="button-container">
        <button class="submit-button" (click)="submitPureOriginalIds()">Submit</button>
    </div>
</div>
